import { render } from "./CaseworkerReviewPage.vue?vue&type=template&id=79677bf4&scoped=true"
import script from "./CaseworkerReviewPage.vue?vue&type=script&lang=js"
export * from "./CaseworkerReviewPage.vue?vue&type=script&lang=js"

import "./CaseworkerReviewPage.vue?vue&type=style&index=0&id=79677bf4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79677bf4"]])

export default __exports__